import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import { Backdrop, Box, Paper, Typography } from '@mui/material';

import { getWindowDimensions, isEmpty } from '../../library/utils';
import Carousel from 'react-material-ui-carousel';

import { setAnnouncementsModalVisible, setBannersModalVisible } from '../../store/actions/banner-actions';

export default function AnnouncementModal() {
    const dispatch = useDispatch();

    const bannersList = useSelector((state) => state.banners.bannersList);
    const announcementsList = useSelector((state) => state.banners.announcementsList);
    const isAnnouncementsModalVisible = useSelector((state) => state.banners.isAnnouncementsModalVisible);

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    const [carouselWidth, setCarouselWidth] = useState(1000);
    const [carouselHeight] = useState(windowDimensions.height);

    const handleClose = () => {
        localStorage.setItem('bannerShown', 'true');

        dispatch(setAnnouncementsModalVisible(false));
        if (bannersList.length > 0) {
            dispatch(setBannersModalVisible(true));
        }
    };

    const handleOpenLink = (url) => {
        window.open(url, '_blank');
    };

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        let finalWidth = windowDimensions.width > 420 ? 420 : windowDimensions.width * 0.9;
        if (finalWidth > windowDimensions.height) {
            finalWidth = windowDimensions.height * 0.9 - 100;
        }
        setCarouselWidth(finalWidth);
    }, [windowDimensions]);

    return (
        <Fragment>
            <Backdrop open={isAnnouncementsModalVisible} sx={{ zIndex: 1000 }} onClick={handleClose}>
                {
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            m: '100%',
                        }}
                    >
                        {announcementsList.length > 0 && (
                            <Carousel
                                sx={{
                                    minWidth: carouselWidth,
                                    width: '100%',
                                    maxHeight: carouselHeight,
                                }}
                                interval={7000}
                                animation={'slide'}
                                navButtonsAlwaysVisible={announcementsList.length > 1}
                                navButtonsAlwaysInvisible={announcementsList.length === 1}
                            >
                                {announcementsList.map((item, i) => (
                                    <Paper
                                        key={i}
                                        style={{
                                            width: carouselWidth,
                                            height: undefined,
                                            display: 'flex',
                                            flexFlow: 'column wrap',
                                            alignItems: 'center',
                                            alignContent: 'center',
                                            backgroundColor: 'transparent',
                                            boxShadow: 'none',
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                backgroundColor: 'white',
                                                minWidth: 200,
                                                minHeight: 100,
                                                borderRadius: 10,
                                                padding: 3,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                textAlign: 'center',
                                            }}
                                        >
                                            <Typography sx={{ paddingBottom: 3 }} variant="h5">
                                                {item.title}
                                            </Typography>
                                            <Typography sx={{ textAlign: 'justify', paddingBottom: 3 }}>{item.description}</Typography>
                                            {!isEmpty(item.redirectUrl) && (
                                                <Button
                                                    autoFocus
                                                    onClick={() => handleOpenLink(item.redirectUrl)}
                                                    sx={{ alignSelf: 'center' }}
                                                >
                                                    Visit Link
                                                </Button>
                                            )}
                                        </Box>
                                    </Paper>
                                ))}
                            </Carousel>
                        )}
                        <Button autoFocus onClick={handleClose} sx={{ alignSelf: 'center', paddingTop: 3 }}>
                            Remind Later
                        </Button>
                    </Box>
                }
            </Backdrop>
        </Fragment>
    );
}
